import {
  GET_KEYWORDS,
  GET_KEYWORDS_SUCCESS,
  RESET_KEYWORDS,
  UPDATE_KEYWORD_FILTERS,
  UPDATE_SEARCH_TERM,
  RESET_KEYWORD_FILTERS,
} from 'Store/Areas/Categorisation/KeywordActions';
import { RESET_PERIOD } from 'Store/Areas/Period/PeriodActions';
import { sortOrder } from 'Constants/Categorization/QueryTermFilters';
import { union } from 'Helpers/ArrayHelpers';

const initialState = {
  loading: false,
  currentPageNumber: 1,
  morePagesAvailable: true,
  keywords: [],
  hasSearched: false,
  minRequestTime: 0,
  filters: {
    sortOrder: sortOrder.valueDescending,
    tagFilter: 0,
    searchTerm: '',
  },
};

function getKeywordsState(state, action) {
  let newState = {
    currentPageNumber: action.payload.currentPageNumber + 1,
    morePagesAvailable: false,
    loading: action.loading,
    hasSearched: action.hasSearched,
  };

  if (!action.isLoadMoreKeywords) {
    newState = {
      ...newState,
      minRequestTime: action.requestTime,
      keywords: [],
    };
  }

  return newState;
}

function getNewKeywordsState(state, action) {
  if (action.requestTime < state.minRequestTime) {
    return null;
  }

  return {
    morePagesAvailable: action.morePagesAvailable,
    loading: action.loading,
    keywords: action.isLoadMoreKeywords
      ? union(state.keywords, action.keywords, k => k.name)
      : action.keywords,
  };
}

export default function keywordReducer(state = initialState, action) {
  switch (action.type) {
    case GET_KEYWORDS:
      return Object.assign({}, state, getKeywordsState(state, action));
    case GET_KEYWORDS_SUCCESS: {
      const newState = getNewKeywordsState(state, action);
      return newState ? Object.assign({}, state, newState) : state;
    }
    case UPDATE_KEYWORD_FILTERS:
      return Object.assign({}, state, {
        filters: {
          sortOrder: action.sortOrder,
          tagFilter: action.tagFilter,
          searchTerm: state.filters.searchTerm,
        },
      });
    case UPDATE_SEARCH_TERM:
      return Object.assign({}, state, {
        filters: {
          sortOrder: state.filters.sortOrder,
          tagFilter: state.filters.tagFilter,
          searchTerm: action.searchTerm,
        },
      });
    case RESET_PERIOD:
    case RESET_KEYWORDS:
    case RESET_KEYWORD_FILTERS:
      return initialState;
    default:
      return state;
  }
}
